import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { resetPassword } from "@/lib/api";
import AuthShell from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Passwort muss mindestens 6 Zeichen haben.");
      return;
    }
    if (password !== confirm) {
      toast.error("Die Passwörter stimmen nicht überein.");
      return;
    }
    setBusy(true);
    try {
      await resetPassword(token, password);
      toast.success("Passwort wurde zurückgesetzt. Bitte anmelden.");
      navigate("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Zurücksetzen fehlgeschlagen.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      title="Neues Passwort"
      subtitle="Vergeben Sie ein neues Passwort für Ihr Konto."
      footer={
        <Link to="/login" className="text-primary font-medium hover:underline">
          Zurück zur Anmeldung
        </Link>
      }
    >
      {!token ? (
        <p className="text-sm text-muted-foreground" data-testid="reset-no-token">
          Ungültiger Link. Bitte fordern Sie einen neuen Link über „Passwort
          vergessen" an.
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <div className="space-y-2">
            <Label htmlFor="password">Neues Passwort</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="new-password" data-testid="reset-password" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="confirm">Passwort bestätigen</Label>
            <Input id="confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required autoComplete="new-password" data-testid="reset-confirm" />
          </div>
          <Button type="submit" className="w-full" disabled={busy} data-testid="reset-submit">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Passwort speichern"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
